import { ParticleOptions } from '../particles.types';

export const getDefaultEmitter = (): ParticleOptions => ({
  autoPlay: true,
  life: {
    count: 1,
    delay: 0.5,
    duration: 1,
    wait: true,
  },
  position: {
    x: 50,
    y: 100,
  },
  rate: {
    quantity: 50,
    delay: 0.125,
  },
  particles: {
    color: {
      value: ['#55476a', '#ae3d63', '#ff3853', '#f45c44', '#f8b646'],
    },
    move: {
      decay: 0.05,
      direction: 'top',
      enable: true,
      gravity: {
        acceleration: 25,
        enable: true,
        maxSpeed: 100,
      },
      outModes: {
        top: 'none',
        default: 'destroy',
      },
      speed: { min: 75, max: 150 },
    },
    opacity: {
      animation: {
        count: 5,
        enable: true,
        startValue: 'random',
      },
      value: {
        max: 1,
        min: 0.25,
      },
    },
    shape: {
      type: ['circle'],
    },
    size: {
      value: {
        max: 6,
        min: 2,
      },
    },
    wobble: {
      distance: {
        max: 30,
        min: 10,
      },
      enable: true,
      speed: {
        max: 10,
        min: -10,
      },
    },
  },
});

export const getBetterEmitter = (chars: string[]): ParticleOptions => ({
  autoPlay: true,
  life: {
    count: 1,
    delay: 0.5,
    duration: 1,
    wait: true,
  },
  position: {
    x: 50,
    y: 100,
  },
  rate: {
    quantity: 25,
    delay: 0.125,
  },
  particles: {
    move: {
      decay: 0.05,
      direction: 'top',
      enable: true,
      gravity: {
        acceleration: 20,
        enable: true,
        maxSpeed: 100,
      },
      outModes: {
        top: 'none',
        default: 'destroy',
      },
      speed: { min: 75, max: 150 },
    },
    opacity: {
      animation: {
        count: 5,
        enable: true,
        startValue: 'random',
      },
      value: {
        max: 1,
        min: 0.25,
      },
    },
    rotate: {
      value: {
        min: 0,
        max: 180,
      },
      direction: 'random',
      animation: {
        enable: true,
        speed: 30,
      },
    },
    shape: {
      type: ['character'],
      options: {
        character: {
          value: chars,
        },
      },
    },
    size: {
      value: {
        max: 12,
        min: 8,
      },
    },
    wobble: {
      distance: {
        max: 30,
        min: 10,
      },
      enable: true,
      speed: {
        max: 10,
        min: -10,
      },
    },
  },
});
